import React, { useState, useEffect } from 'react';
import EventIndexComponent from './Index.component';

const EventIndexContainer: React.FC = () => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // TODO: 이벤트 목록 API 호출 추가
        const fetchEventList = async () => {
            try {
                setIsLoading(true);
                // const result = await getEventList();
                // TODO: API 연동
                // 일단 기본 이벤트 항목은 컴포넌트에서 표시
            } catch (error) {
                console.error('이벤트 목록 조회 실패:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchEventList();
    }, []);

    return (
        <EventIndexComponent
            isLoading={isLoading}
        />
    );
};

export default EventIndexContainer;
